export default function Plot_D3JS() {
  return (
    <div>
      <h1>Plot_D3JS Component</h1>
    </div>
  );
}
